export default function ProductData() {
  return {
    products: [
      {
        productIconPath: "calendar",
        displayName: "TERM LIFE INSURANCE",
        productType: "term",
        productLink: "/landing/term-insurance",
      }
    ]
  }
}